import React, { useEffect, useState } from 'react';
import { Banner, Icon, TextStyle } from '@shopify/polaris';
import { getShop } from 'src/helpers';
import { LockMinor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';
import {
  ADDONS_INFO,
  AI_POWERED_SEARCH_NAME,
  SUBSCRIPTION_STATE
} from 'src/constants/subscription';
import ProcessAddon from 'src/components/views/subscription-v3/addon/process-addon';
import enhanceAISearch from 'src/assets/images/subscription-v3/enhance-ai-search.png';
import { getAISearchStatus } from 'src/helpers/search-settings-helper';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as subscriptionV3Actions from 'actions/subscription-v3-actions';

const EnhanceAISearchBanner = props => {
  const { i18n, aiSearchStatus, notAllowAddon, enableAISearch, getAddonStatus } = props;
  const [dismissedBanner, setDismissedBanner] = useState(false);
  const [modalAddon, setModalAddon] = useState(false);
  const isSubscribeNow = aiSearchStatus !== SUBSCRIPTION_STATE.NOT_TRIAL;

  const getKeyDismiss = shop => `${shop}-dismissEnhanceAISearch`;

  const checkDismissedBanner = () => {
    const shop = getShop();
    let dismissed = false;
    try {
      dismissed = localStorage.getItem(getKeyDismiss(shop));
    } catch (error) {}

    if (dismissed === 'true') {
      setDismissedBanner(true);
    }
  };

  const onDismiss = () => {
    const shop = getShop();
    try {
      localStorage.setItem(getKeyDismiss(shop), true);
    } catch (error) {}

    setDismissedBanner(true);
  };

  const openLink = (id: string) => {
    const newUrl = URL[id];
    window.open(newUrl, '_blank');
  };
  useEffect(() => {
    checkDismissedBanner();
    // eslint-disable-next-line
  }, []);

  if (enableAISearch || dismissedBanner) {
    return <></>;
  }

  return (
    <div
      className={`enhance-ai-search-banner banner-unlock-addon ${
        notAllowAddon ? 'enhance-ai-search-banner-disabled' : ''
      }`}>
      <Banner
        title={i18n.translate('AdminHTML.AdvanceSearch.Banner.Enhance.title')}
        status="warning"
        onDismiss={onDismiss}
        action={{
          content: (
            <div className="action-locked">
              <Icon source={LockMinor} />
              <TextStyle variation="strong">
                {i18n.translate(
                  `AdminHTML.Common.Action.${
                    isSubscribeNow ? 'unLockNow' : 'unlockFeatureForTrial'
                  }`
                )}
              </TextStyle>
            </div>
          ),
          onAction: () => setModalAddon(true),
          disabled: notAllowAddon
        }}
        secondaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.learnMore'),
          onAction: () => openLink('AI_Powered_Search')
        }}>
        <div className="banner-content">
          <div className="description">
            <p>
              {i18n.translate('AdminHTML.AdvanceSearch.Banner.Enhance.description1', {
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.AdvanceSearch.Banner.Enhance.description1_t1')}
                  </TextStyle>
                ),
                t2: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.AdvanceSearch.Banner.Enhance.description1_t2')}
                  </TextStyle>
                )
              })}
            </p>
            <p>{i18n.translate('AdminHTML.AdvanceSearch.Banner.Enhance.description2')}</p>
          </div>
          <img src={enhanceAISearch} alt="enhance-ai-search" />
        </div>
      </Banner>
      <ProcessAddon
        openModalReview={modalAddon}
        addon={ADDONS_INFO.find(e => e.addonName === AI_POWERED_SEARCH_NAME)}
        hadSubscribed={isSubscribeNow}
        handleAfterSubscribeAddon={() => getAddonStatus(AI_POWERED_SEARCH_NAME)}
        handleReviewModal={() => setModalAddon(!modalAddon)}
      />
    </div>
  );
};

const mapStateToProps = state => {
  const enableAISearch = _.get(
    state.oauth.tenantApp,
    'settings.instantSearch.settings.AI-synonyms',
    false
  );
  const statusStore = _.get(state.oauth, 'subscription.status', '');
  const addonStatus = _.get(state.subscriptionV3, 'addonStatus', {});

  return {
    notAllowAddon: _.get(state.oauth, 'subscription.notAllowAddon', false),
    enableAISearch,
    aiSearchStatus: getAISearchStatus(enableAISearch, statusStore, addonStatus)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getAddonStatus: addonName => dispatch(subscriptionV3Actions.getAddonStatus(addonName))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(EnhanceAISearchBanner));
